import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchReceptacleTransportOverview = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getReceptacleTransportOverview',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchReceptacleTransportOverview;
